import React from 'react'
import '../css/spinner.css'

class LoadingSpinnerSmall extends React.Component {
  render() {
    return (
      <div className="sk-fading-circle" style={{height: '50px', width: '50px', margin: '0 15px 0 0'}}  >
        <div className="sk-circle1 sk-circle" />
        <div className="sk-circle2 sk-circle" />
        <div className="sk-circle3 sk-circle" />
        <div className="sk-circle4 sk-circle" />
        <div className="sk-circle5 sk-circle" />
        <div className="sk-circle6 sk-circle" />
        <div className="sk-circle7 sk-circle" />
        <div className="sk-circle8 sk-circle" />
        <div className="sk-circle9 sk-circle" />
        <div className="sk-circle10 sk-circle" />
        <div className="sk-circle11 sk-circle" />
        <div className="sk-circle12 sk-circle" />
      </div>
    )
  }
}

export default LoadingSpinnerSmall
